// extracted by mini-css-extract-plugin
export default {"text":"TruncatedText_text__EbEXL","truncatedTextShowMore":"TruncatedText_truncatedTextShowMore__e3fr7","truncatedTextShowMoreText":"TruncatedText_truncatedTextShowMoreText__fBWYs"};